<header
  class="sticky top-0 z-30 backdrop-blur-lg bg-white/90 border-b border-primary-100 shadow-lg shadow-primary-100/20 animate-fadeIn"
>
  <div class="max-w-7xl mx-auto">
    <div class="flex justify-between items-center px-8 py-4">
      <div class="logo-container flex items-center space-x-4">
        <!-- Animated Logo -->
        <div class="logo-wrapper relative animate-scaleIn">
          <div
            class="absolute inset-0 bg-gradient-to-r from-primary-400 to-primary-500 rounded-lg blur-lg animate-pulse opacity-50"
          ></div>
          <div
            class="relative w-10 h-10 rounded-lg bg-gradient-to-r from-primary-50 to-primary-100 flex items-center justify-center border border-primary-200 group hover:scale-105 transition-all duration-300 ease-out"
          >
            <span
              class="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-700 font-bold text-lg group-hover:animate-bounce"
              >R</span
            >
          </div>
        </div>
        <!-- Animated Company Name -->
        <h1 class="text-xl font-bold tracking-wide animate-slideInRight">
          <span
            class="inline-block animate-gradient bg-gradient-to-r from-primary-600 via-primary-700 to-primary-600 text-transparent bg-clip-text bg-300% hover:bg-150%"
          >
            Rectilineus Admin
          </span>
        </h1>
      </div>

      <!-- Navigation with Animated Effects -->
      <nav class="flex items-center space-x-8 animate-slideInLeft">
        <a
          routerLink="/"
          class="nav-link group relative text-gray-600 font-medium transition-colors duration-300"
        >
          <span
            class="relative inline-block hover:-translate-y-0.5 transition-transform duration-300"
          >
            Dashboard
            <span
              class="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-primary-600 to-primary-700 group-hover:w-full transition-all duration-300"
            ></span>
          </span>
        </a>
        <button
          class="relative px-5 py-2.5 text-white font-medium rounded-lg overflow-hidden group"
          (click)="logout()"
        >
          <span
            class="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-primary-600 to-primary-700 transition-all duration-300"
          ></span>
          <span class="relative flex items-center space-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            <span>Logout</span>
          </span>
          <div
            class="absolute inset-0 bg-gradient-to-r from-primary-700 to-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          ></div>
        </button>
      </nav>
    </div>
  </div>
</header>
